/* eslint-disable*/
let domain;
if (process.env.VUE_APP_MODE === 'test') {
  domain = '//ecsh5.ileci.com';
} else if (process.env.VUE_APP_MODE === 'production') {
  domain = '//h5.ileci.com';
} else if (process.env.VUE_APP_MODE === 'development') {
  domain = '//devh5.ileci.com';
} else {
  domain = '';
}
export default domain;
